// extracted by mini-css-extract-plugin
module.exports = {"block":"_7851","hd":"_242","title":"_7902","arrow":"_6688","empty":"_2461","bd":"_10447","ft":"_15757"};